import { Component, OnInit } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { Pagination, PaginationRequest } from 'src/app/core/models/pagination.model';
import { Team } from 'src/app/core/models/team.model';
import { User } from 'src/app/core/models/user.model';
import { ConfigService } from 'src/app/core/services/config.service';
import { UserService } from 'src/app/core/services/user.service';
import * as utils from 'src/app/shared/helpers/utils';

@Component({
  selector: 'hbo-team-list',
  templateUrl: './team-list.component.html',
  styleUrls: ['./team-list.component.scss']
})
export class TeamListComponent implements OnInit {

  teams$ = new Observable<Pagination<Team>>;
  teamsCollection$: Team[] = [];
  user: User = utils?.localStorageGetItem('user');

  constructor(
    private userService: UserService,
    private configSvc: ConfigService
  ) {
    this.getTeams();
  }

  ngOnInit() {
    this.searchTeams();
  }

  searchTeams(pagination?: PaginationRequest, reload = false) {
    console.log(pagination);
    this.teams$ = this.userService.getTeams(pagination ?? { sort: 'id', order: 'desc' }, true).pipe(tap(result => this.teamsCollection$ = result.data));
  }

  getTeams = () => {
    if (!this.configSvc.currentConfigValue.teams) {
      this.userService.getTeams({ perPage: -1 }).subscribe(teams => {
        this.configSvc.setConfigParamsValue('teams', teams.data);
      });
    }
  }

  callback = (e: any) => {
    switch (e.action) {
      case 'updated':
        const propsToRemove = [];
        this.teamsCollection$.map((t: Team) => {
          if (t.id === e.result.id) { utils.deepMerge(t, e.result) };
        })
        break;
      case 'deleted':
        this.searchTeams();
        break;
      default:
        break;
    }
  }

}
